module.exports = __webpack_public_path__ + "static/media/warning.e7d59f4d.svg";